module.exports = __webpack_public_path__ + "static/img/wordart.c7c7d67.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/construction/wordart.gif
// module id = PcGg
// module chunks = 0